module.exports = __webpack_public_path__ + "static/media/loading.49db5812.gif";